import React from 'react';

const CorsoCardLoading = () => {
    return (
        <div className="col-md-6 col-xl-3 my-2 loading-card">
          <div className="card" aria-hidden="true">
            <span className="card-img-top" style={{backgroundColor: '#868e96'}}></span>
            <div className="card-body">
              <h5 className="card-title placeholder-glow">
                <span className="placeholder col-6"></span>
              </h5>
              <p className="card-text placeholder-glow">
                <span className="placeholder col-7"></span>
                <span className="placeholder col-4"></span>
                <span className="placeholder col-4"></span>
                <span className="placeholder col-6"></span>
                <span className="placeholder col-8"></span>
              </p>
              <a className="btn btn-primary disabled placeholder col-6" aria-disabled="true"></a>
            </div>
          </div>
        </div>
      );
};

export default CorsoCardLoading;
